import { render, staticRenderFns } from "./Global.vue?vue&type=template&id=707959d8"
import script from "./Global.vue?vue&type=script&lang=js"
export * from "./Global.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports